
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

import { Company } from "@/generated/graphql";
import RouteTabs from "@/entities/RouteTabs";
import RouteNames from "@/entities/RouteNames";
import TabsWithRoutes from "@/components/common/TabsWithRoutesNew.vue";
import GET_MARKETPLACE_ACCESS_REQUESTS from "@/apollo/company/GetMarketplaceRequestsCount.gql";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import TabNotificationBubble from "@/components/common/TabNotificationBubble.vue";

@Component({
  components: {
    TabNotificationBubble,
    LoadingOverlay,
    TabsWithRoutes,
  },
  apollo: {
    requestsCount: {
      query: GET_MARKETPLACE_ACCESS_REQUESTS,
      update(data) {
        return data.manager_aggregate.aggregate.count;
      },
    },
  },
})
export default class CompanySettingsTabs extends Vue {
  @Prop({ type: Object, required: true }) readonly company!: Company;

  requestsCount: number = 0;
  RouteNames = RouteNames;

 get routeTabs(): RouteTabs {
    return {
      // [RouteNames.COMPANY_INTERFACE_SETTINGS]: `Marketplace Permissions`,
      [RouteNames.COMPANY_MARKETPLACE_ACCESS_REQUESTS]: `Resource Permissions`,
    };
  }


  get requestsExist(): boolean {
    return this.requestsCount > 0;
  }

  get isLoading(): boolean {
    return this.$apollo.queries.requestsCount.loading;
  }
}
